import { useI18n } from "@/i18n";

const STEPS = ["question", "notes", "items", "options"];

export const StepAxis = ({ step }) => {
  const { t } = useI18n();
  return (
    <ol data-testid="step-axis" className="m-0 mt-6 grid list-none grid-cols-4 p-0">
      {STEPS.map((key, i) => {
        const n = i + 1;
        const done = n < step;
        const current = n === step;
        const name = t(`intake.step.${key}`);
        return (
          <li
            key={key}
            aria-current={current ? "step" : undefined}
            data-testid={`step-node-${n}`}
            data-state={done ? "done" : current ? "current" : "next"}
            className="min-w-0"
          >
            <div className="flex items-center">
              <span
                aria-hidden="true"
                className={`h-[2px] flex-1 ${i === 0 ? "bg-transparent" : n <= step ? "bg-ax-accent" : "bg-ax-border"}`}
              />
              <span
                aria-hidden="true"
                className={`box-border block h-2 w-2 shrink-0 rounded-full border-[2px] ${
                  done
                    ? "border-ax-accent bg-ax-accent"
                    : current
                      ? "border-ax-accent bg-ax-bg"
                      : "border-ax-border bg-ax-bg"
                }`}
                style={{ width: 10, height: 10 }}
              />
              <span
                aria-hidden="true"
                className={`h-[2px] flex-1 ${i === STEPS.length - 1 ? "bg-transparent" : n < step ? "bg-ax-accent" : "bg-ax-border"}`}
              />
            </div>
            <span className="sr-only">{t("intake.stepSr", { n, name })}</span>
            <span
              aria-hidden="true"
              className={`mt-2 block px-1 text-center text-xs leading-4 [overflow-wrap:anywhere] ${
                current ? "font-medium text-ax-link" : "text-ax-muted"
              }`}
            >
              {name}
            </span>
          </li>
        );
      })}
    </ol>
  );
};
